export default {
  AmqpQueuesList: 'AmqpQueuesList',
};
